export const USER_TYPES = {
  ALL: "",
  PERSONAL: "personal",
  COMMERCIAL: "commercial",
};

export const userTypeLabels = () => {
  return {
    [USER_TYPES.PERSONAL]: "Personal",
    [USER_TYPES.COMMERCIAL]: "Commercial",
  };
};

export const userTypeFilters = () => [
  { value: USER_TYPES.ALL, label: "All" },
  { value: USER_TYPES.PERSONAL, label: userTypeLabels()[USER_TYPES.PERSONAL] },
  { value: USER_TYPES.COMMERCIAL, label: userTypeLabels()[USER_TYPES.COMMERCIAL] },
];
